export const PRIVACY = {
  fr: {
    link: "Politique de confidentialité",
    title: "Politique de confidentialité",
    updated: "Dernière mise à jour : octobre 2026",
    back: "Retour au site",
    sections: [
      {
        h: "Le responsable du traitement",
        p: "Rest'Ô Bréda SARL, 1850 Route du Haut-Bréda, 38580 Le Haut-Bréda, France, est responsable du traitement des données personnelles collectées via ce site.",
      },
      {
        h: "Les données que nous collectons",
        p: "Ce site ne comporte ni formulaire ni espace de compte : nous ne collectons aucune donnée de navigation à des fins de suivi. Votre choix de langue est simplement mémorisé sur votre appareil (stockage local), sans cookie tiers. Si vous nous écrivez à contact@restobreda.com ou privacy@restobreda.com, nous recevons votre adresse email et le contenu de votre message.",
      },
      {
        h: "Pourquoi et sur quelle base",
        p: "Ces données servent uniquement à répondre à vos demandes. Le traitement repose sur votre consentement et notre intérêt légitime à vous répondre.",
      },
      {
        h: "Durée de conservation",
        p: "Les échanges par email sont conservés le temps nécessaire au traitement de votre demande, puis archivés au maximum trois ans, sauf obligation légale contraire.",
      },
      {
        h: "Vos droits",
        p: "Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de vos données. Pour les exercer, écrivez à privacy@restobreda.com. Vous pouvez également adresser une réclamation à la CNIL (cnil.fr).",
      },
    ],
    contactLabel: "Contact confidentialité",
    contactText: "Pour toute question relative à cette politique ou à vos données :",
  },
  en: {
    link: "Privacy policy",
    title: "Privacy Policy",
    updated: "Last updated: October 2026",
    back: "Back to site",
    sections: [
      {
        h: "Data controller",
        p: "Rest'Ô Bréda SARL, 1850 Route du Haut-Bréda, 38580 Le Haut-Bréda, France, is the controller of the personal data collected through this site.",
      },
      {
        h: "Data we collect",
        p: "This site has no form and no account area: we collect no browsing data for tracking purposes. Your language choice is simply stored on your device (local storage), with no third-party cookies. If you write to contact@restobreda.com or privacy@restobreda.com, we receive your email address and the content of your message.",
      },
      {
        h: "Why and on what legal basis",
        p: "This data is used solely to answer your requests. Processing is based on your consent and our legitimate interest in replying to you.",
      },
      {
        h: "Retention period",
        p: "Email exchanges are kept for as long as needed to handle your request, then archived for up to three years, unless a legal obligation requires otherwise.",
      },
      {
        h: "Your rights",
        p: "You have the right to access, rectify, erase, object to and port your data. To exercise them, write to privacy@restobreda.com. You may also lodge a complaint with the CNIL (cnil.fr).",
      },
    ],
    contactLabel: "Privacy contact",
    contactText: "For any question about this policy or your data:",
  },
  es: {
    link: "Política de privacidad",
    title: "Política de privacidad",
    updated: "Última actualización: octubre de 2026",
    back: "Volver al sitio",
    sections: [
      {
        h: "Responsable del tratamiento",
        p: "Rest'Ô Bréda SARL, 1850 Route du Haut-Bréda, 38580 Le Haut-Bréda, Francia, es responsable del tratamiento de los datos personales recogidos a través de este sitio.",
      },
      {
        h: "Datos que recogemos",
        p: "Este sitio no tiene formularios ni área de cuenta: no recogemos datos de navegación con fines de seguimiento. Su elección de idioma simplemente se guarda en su dispositivo (almacenamiento local), sin cookies de terceros. Si nos escribe a contact@restobreda.com o privacy@restobreda.com, recibimos su dirección de correo y el contenido de su mensaje.",
      },
      {
        h: "Por qué y con qué base legal",
        p: "Estos datos se utilizan únicamente para responder a sus solicitudes. El tratamiento se basa en su consentimiento y en nuestro interés legítimo en responderle.",
      },
      {
        h: "Plazo de conservación",
        p: "Los intercambios por correo se conservan el tiempo necesario para tramitar su solicitud y después se archivan durante un máximo de tres años, salvo obligación legal en contrario.",
      },
      {
        h: "Sus derechos",
        p: "Tiene derecho de acceso, rectificación, supresión, oposición y portabilidad de sus datos. Para ejercerlos, escriba a privacy@restobreda.com. También puede presentar una reclamación ante la CNIL (cnil.fr).",
      },
    ],
    contactLabel: "Contacto de privacidad",
    contactText: "Para cualquier pregunta sobre esta política o sus datos:",
  },
  de: {
    link: "Datenschutzerklärung",
    title: "Datenschutzerklärung",
    updated: "Zuletzt aktualisiert: Oktober 2026",
    back: "Zurück zur Website",
    sections: [
      {
        h: "Verantwortlicher",
        p: "Rest'Ô Bréda SARL, 1850 Route du Haut-Bréda, 38580 Le Haut-Bréda, Frankreich, ist für die Verarbeitung der über diese Website erhobenen personenbezogenen Daten verantwortlich.",
      },
      {
        h: "Welche Daten wir erheben",
        p: "Diese Website enthält weder Formulare noch einen Kontobereich: Wir erheben keine Navigationsdaten zu Tracking-Zwecken. Ihre Sprachwahl wird lediglich auf Ihrem Gerät gespeichert (lokaler Speicher), ohne Drittanbieter-Cookies. Wenn Sie an contact@restobreda.com oder privacy@restobreda.com schreiben, erhalten wir Ihre E-Mail-Adresse und den Inhalt Ihrer Nachricht.",
      },
      {
        h: "Warum und auf welcher Rechtsgrundlage",
        p: "Diese Daten dienen ausschließlich der Beantwortung Ihrer Anfragen. Die Verarbeitung beruht auf Ihrer Einwilligung und unserem berechtigten Interesse, Ihnen zu antworten.",
      },
      {
        h: "Speicherdauer",
        p: "E-Mail-Korrespondenz wird so lange aufbewahrt, wie es zur Bearbeitung Ihrer Anfrage nötig ist, und anschließend bis zu drei Jahre archiviert, sofern keine gesetzliche Pflicht etwas anderes vorsieht.",
      },
      {
        h: "Ihre Rechte",
        p: "Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Widerspruch und Datenübertragbarkeit. Zur Ausübung schreiben Sie an privacy@restobreda.com. Sie können sich auch bei der CNIL (cnil.fr) beschweren.",
      },
    ],
    contactLabel: "Datenschutz-Kontakt",
    contactText: "Bei Fragen zu dieser Erklärung oder Ihren Daten:",
  },
  it: {
    link: "Informativa sulla privacy",
    title: "Informativa sulla privacy",
    updated: "Ultimo aggiornamento: ottobre 2026",
    back: "Torna al sito",
    sections: [
      {
        h: "Titolare del trattamento",
        p: "Rest'Ô Bréda SARL, 1850 Route du Haut-Bréda, 38580 Le Haut-Bréda, Francia, è titolare del trattamento dei dati personali raccolti tramite questo sito.",
      },
      {
        h: "Dati che raccogliamo",
        p: "Questo sito non ha moduli né area account: non raccogliamo dati di navigazione a fini di tracciamento. La tua scelta della lingua è semplicemente memorizzata sul tuo dispositivo (archiviazione locale), senza cookie di terze parti. Se ci scrivi a contact@restobreda.com o privacy@restobreda.com, riceviamo il tuo indirizzo email e il contenuto del messaggio.",
      },
      {
        h: "Perché e su quale base giuridica",
        p: "Questi dati servono unicamente a rispondere alle tue richieste. Il trattamento si basa sul tuo consenso e sul nostro legittimo interesse a risponderti.",
      },
      {
        h: "Periodo di conservazione",
        p: "Gli scambi via email sono conservati per il tempo necessario a gestire la tua richiesta, poi archiviati per un massimo di tre anni, salvo obbligo legale diverso.",
      },
      {
        h: "I tuoi diritti",
        p: "Hai diritto di accesso, rettifica, cancellazione, opposizione e portabilità dei tuoi dati. Per esercitarli, scrivi a privacy@restobreda.com. Puoi anche presentare reclamo alla CNIL (cnil.fr).",
      },
    ],
    contactLabel: "Contatto privacy",
    contactText: "Per qualsiasi domanda su questa informativa o sui tuoi dati:",
  },
  nl: {
    link: "Privacybeleid",
    title: "Privacybeleid",
    updated: "Laatst bijgewerkt: oktober 2026",
    back: "Terug naar de site",
    sections: [
      {
        h: "Verwerkingsverantwoordelijke",
        p: "Rest'Ô Bréda SARL, 1850 Route du Haut-Bréda, 38580 Le Haut-Bréda, Frankrijk, is verantwoordelijk voor de verwerking van persoonsgegevens die via deze site worden verzameld.",
      },
      {
        h: "Welke gegevens we verzamelen",
        p: "Deze site heeft geen formulier of accountgedeelte: we verzamelen geen browsegegevens voor tracking. Uw taalkeuze wordt alleen op uw apparaat opgeslagen (lokale opslag), zonder cookies van derden. Als u schrijft naar contact@restobreda.com of privacy@restobreda.com, ontvangen wij uw e-mailadres en de inhoud van uw bericht.",
      },
      {
        h: "Waarom en op welke rechtsgrond",
        p: "Deze gegevens worden uitsluitend gebruikt om uw verzoeken te beantwoorden. De verwerking berust op uw toestemming en ons gerechtvaardigd belang om u te antwoorden.",
      },
      {
        h: "Bewaartermijn",
        p: "E-mailwisselingen worden bewaard zolang als nodig is om uw verzoek te behandelen, en vervolgens maximaal drie jaar gearchiveerd, tenzij een wettelijke verplichting anders voorschrijft.",
      },
      {
        h: "Uw rechten",
        p: "U heeft recht op inzage, rectificatie, verwijdering, bezwaar en overdraagbaarheid van uw gegevens. Schrijf hiervoor naar privacy@restobreda.com. U kunt ook een klacht indienen bij de CNIL (cnil.fr).",
      },
    ],
    contactLabel: "Privacycontact",
    contactText: "Voor vragen over dit beleid of uw gegevens:",
  },
  ru: {
    link: "Политика конфиденциальности",
    title: "Политика конфиденциальности",
    updated: "Последнее обновление: октябрь 2026 г.",
    back: "Вернуться на сайт",
    sections: [
      {
        h: "Оператор данных",
        p: "Rest'Ô Bréda SARL, 1850 Route du Haut-Bréda, 38580 Le Haut-Bréda, Франция, является оператором персональных данных, собираемых через этот сайт.",
      },
      {
        h: "Какие данные мы собираем",
        p: "На сайте нет форм и личных кабинетов: мы не собираем данные о просмотрах для отслеживания. Ваш выбор языка просто сохраняется на вашем устройстве (локальное хранилище), без сторонних файлов cookie. Если вы пишете на contact@restobreda.com или privacy@restobreda.com, мы получаем ваш адрес электронной почты и содержание сообщения.",
      },
      {
        h: "Зачем и на каком основании",
        p: "Эти данные используются только для ответа на ваши запросы. Обработка основана на вашем согласии и нашем законном интересе ответить вам.",
      },
      {
        h: "Срок хранения",
        p: "Переписка по электронной почте хранится столько, сколько необходимо для обработки вашего запроса, затем архивируется на срок не более трёх лет, если иное не требуется законом.",
      },
      {
        h: "Ваши права",
        p: "Вы имеете право на доступ, исправление, удаление, возражение и переносимость ваших данных. Для их реализации пишите на privacy@restobreda.com. Вы также можете подать жалобу в CNIL (cnil.fr).",
      },
    ],
    contactLabel: "Контакт по конфиденциальности",
    contactText: "По любым вопросам об этой политике или ваших данных:",
  },
  uk: {
    link: "Політика конфіденційності",
    title: "Політика конфіденційності",
    updated: "Останнє оновлення: жовтень 2026 р.",
    back: "Повернутися на сайт",
    sections: [
      {
        h: "Оператор даних",
        p: "Rest'Ô Bréda SARL, 1850 Route du Haut-Bréda, 38580 Le Haut-Bréda, Франція, є оператором персональних даних, що збираються через цей сайт.",
      },
      {
        h: "Які дані ми збираємо",
        p: "На сайті немає форм та особистих кабінетів: ми не збираємо дані про перегляди для відстеження. Ваш вибір мови просто зберігається на вашому пристрої (локальне сховище), без сторонніх файлів cookie. Якщо ви пишете на contact@restobreda.com або privacy@restobreda.com, ми отримуємо вашу адресу електронної пошти та зміст повідомлення.",
      },
      {
        h: "Навіщо і на якій підставі",
        p: "Ці дані використовуються лише для відповіді на ваші запити. Обробка ґрунтується на вашій згоді та нашому законному інтересі відповісти вам.",
      },
      {
        h: "Термін зберігання",
        p: "Листування електронною поштою зберігається стільки, скільки потрібно для обробки вашого запиту, а потім архівується не більше ніж на три роки, якщо інше не вимагає закон.",
      },
      {
        h: "Ваші права",
        p: "Ви маєте право на доступ, виправлення, видалення, заперечення та перенесення ваших даних. Для цього пишіть на privacy@restobreda.com. Ви також можете подати скаргу до CNIL (cnil.fr).",
      },
    ],
    contactLabel: "Контакт з конфіденційності",
    contactText: "З будь-яких питань щодо цієї політики або ваших даних:",
  },
};
